module.exports = __webpack_public_path__ + "img/SafeguardingInformation.e9136d05.jpg";